/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum UserStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    INVITED = 'INVITED',
}
